<template>
    <el-card class="app-section secondary">
        <slot />
    </el-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
const AppSection = defineComponent({});
export default AppSection;
</script>
<style>
.app-section {
    margin-bottom: 20px;
    margin-top: 20px;
    padding: 16px;
}
</style>
